//@ts-nocheck
import {Subject} from "rxjs";

export class TransactionResult {
  constructor(private source: any, public settled: boolean = false, public success: boolean = false,
              public progress: number = 0, public error: any = null, public data: Array<any> = [],
              public lastData: any = null, public body: any = null) {}
}

export class DeviceTransactionResult extends TransactionResult{
  constructor(public device) {
    super(device);
  }
}



export class PendingTransactionResult {
  private seq: number = 0;
  private last: number = Infinity;
  private unplaced: Array<any> = [];

  public subject: Subject<TransactionResult> = new Subject();

  public result: TransactionResult;

  constructor(result: TransactionResult) {
    this.result = result;

    this.subject.subscribe(
      // TODO: handle progress properly
      () => {},
      (error) => {console.warn(error)},
      () => {
        result.settled = true;
        result.progress = 100;
      });
  }

  private readQueue() {
    let message;
    let foundAny: boolean = false;


    while (this.seq <= this.last && (message = this.unplaced[this.seq])) {
      this.unplaced[this.seq] = undefined;

      if (this.seq === this.last) {
        this.result.success = message.success;

        if (message.body) {
          this.result.body = JSON.parse(message.body);
        }

        if (this.result.success) {
          if (message.data) {
            this.result.lastData = this.result.data[this.seq] = message.data;
          }
          this.subject.next(this.result);
          this.subject.complete();
        }
        else {
          this.result.lastData = this.result.error = message.data;
          this.subject.error(this.result.error);
        }

        return;
      }
      else {
        if (message.progress) {
          this.result.progress = message.progress;
        }
      }

      foundAny = true;
      this.result.lastData = this.result.data[this.seq++] = message.data;
    }

    if (foundAny) {
      this.subject.next(this.result);
    }
  }

  public progress(message) {
    this.unplaced[message.seq] = message;
    this.readQueue();
  }

  public done(message) {
    this.last = message.seq;
    this.unplaced[message.seq] = message;
    this.readQueue();
  }

  public cancel(message) {
    if (!this.result.settled) {
      this.last = message.seq = this.seq;
      this.unplaced[message.seq] = message;
      this.readQueue();
    }
  }
}
